import { GetterTree } from "vuex";
import { RootState } from "../types";
import { ClientsState } from "./types";

export const getters: GetterTree<ClientsState, RootState> = {
  getRefresh(state): boolean {
    return state.refresh;
  },
};
